<script lang="ts" setup>
import { useModal } from 'vue-final-modal'

import Dolyame from '~/components/modal-windows/Dolyame.vue'
import formatter from '~/helpers/formatter'

const props = withDefaults(
  defineProps<{
    price: number
    isWideOnMobile?: boolean
  }>(),
  { isWideOnMobile: false }
)

const installmentsCount = 4
const minPrice = 4
const maxPrice = 30000

const enableButton = computed(() => props.price >= minPrice && props.price <= maxPrice)
const equalPaymentAmount = computed(() => Math.floor(props.price / installmentsCount))

async function openDolyameModalWindow (): Promise<void> {
  await useModal({ component: Dolyame, attrs: { price: props.price } }).open()
}
</script>

<template>
  <button
    v-if="enableButton"
    class="
      flex w-full items-center justify-between rounded-2xl bg-[#f7f7f7] py-4 pl-3 pr-2 md:p-4
    "
    @click.prevent="openDolyameModalWindow"
  >
    <div class="flex items-center">
      <SvgIcon class="!h-[26px] !w-[78px]" name="payment-methods/dolyame-white" />

      <span class="mx-3 block text-sm md:mx-2 md:text-base">
        {{ installmentsCount }}&nbsp;платежа по&nbsp;{{ formatter.formatPrice(equalPaymentAmount) }}&nbsp;₽
      </span>
    </div>

    <SvgIcon class="!size-5" name="outlined/ui-next-arrow" />
  </button>
</template>
